import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import { styled } from "@mui/material";
import { Modal, modalClasses, ModalCloseButton, ModalContent } from "@kaltura/ds-react-components";
import { generalHtmlStyles } from "@kaltura/mediaspace-shared-ui";
import { alpha } from "@kaltura/mediaspace-shared-styled";

export interface DescriptionModalProps {
    open: boolean;
    onClose: () => void;
    description: string;
}

/**
 * Meeting room card to display in the BSE embed.
 */
export const DescriptionModal = ({ open, onClose, description }: DescriptionModalProps) => {
    return (
        <StyledModal variant={"content"} fullScreen={true} open={open} onClose={onClose}>
            <ModalCloseButton onClick={onClose} color={"translucent"} />
            <StyledModalContent>{HtmlReactParser(description)}</StyledModalContent>
        </StyledModal>
    );
};

const StyledModal = styled(Modal)(({ theme }) => ({
    // Double the class name to increase rule specificity
    [`.${modalClasses.paper}.${modalClasses.paper}`]: {
        backgroundColor: alpha(theme.kaltura.palette.translucent.commonBlack, 0.8),
    },
}));

const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    color: theme.kaltura.palette.translucent.contrastText,
    ...generalHtmlStyles(theme),
}));
